import * as React from 'react';

import { LodgingEnrichedMessage } from 'components/common/schema-types/messages/lodging-enriched-message';
import { LodgingEnrichedMessageFragment } from 'src/common/__generated__/api/types';
import { Message } from 'models';

type LodgingEnrichedMessageModel = LodgingEnrichedMessageFragment.Fragment;

export interface PriceMessagesProps {
  priceMessages?: Message[];
}

export const PriceMessages: React.FunctionComponent<PriceMessagesProps> = ({ priceMessages }) => (
  <div data-stid="price-messages">
    {priceMessages &&
      priceMessages.length > 0 &&
      priceMessages.map(
        message =>
          message &&
          message.value && (
            <div className="pwa-theme--grey-700 uitk-type-100 uitk-type-regular" key={message.value}>
              {message.value}
            </div>
          )
      )}
  </div>
);
PriceMessages.displayName = 'PriceMessages';

export interface PriceMessagingProps {
  priceMessaging?: LodgingEnrichedMessageModel[];
}

export const PriceMessaging: React.FunctionComponent<PriceMessagingProps> = ({ priceMessaging }) => {
  if (priceMessaging?.length === 0) {
    return null;
  }

  return (
    <div className="all-t-padding-one" data-stid="price-lockup-wrapper">
      {priceMessaging.map((message, index) => (
        <LodgingEnrichedMessage key={`price-messaging-${index}`} size={100} value={message.value} theme={message.theme} />
      ))}
    </div>
  );
};
PriceMessaging.displayName = 'PriceMessaging';

export interface NumberOfNightsAndRoomsProps {
  numberOfNightsAndRooms?: string;
}

export const NumberOfNightsAndRooms: React.FunctionComponent<NumberOfNightsAndRoomsProps> = ({ numberOfNightsAndRooms }) =>
  numberOfNightsAndRooms ? (
    <div className="numberOfNightsAndRooms pwa-theme--grey-700 uitk-type-100 uitk-type-regular">{numberOfNightsAndRooms}</div>
  ) : null;
NumberOfNightsAndRooms.displayName = 'NumberOfNightsAndRooms';

export interface PriceMessagesContainerProps extends PriceMessagesProps, PriceMessagingProps {
  numberOfNightsAndRooms?: string;
}

export const PriceMessagesContainer: React.FunctionComponent<PriceMessagesContainerProps> = props => {
  const { priceMessages, priceMessaging, numberOfNightsAndRooms } = props;
  const showPriceMessaging = priceMessages || priceMessaging;

  const priceMessagingComponent = priceMessaging ? <PriceMessaging {...{ priceMessaging }} /> : <PriceMessages {...{ priceMessages }} />;

  return showPriceMessaging ? priceMessagingComponent : <NumberOfNightsAndRooms {...{ numberOfNightsAndRooms }} />;
};
PriceMessagesContainer.displayName = 'PriceMessagesContainer';
